<template>
<div  class="nutritionSettingsindex">
     <div class="header">    
        <el-button type="primary" size="medium" @click="insertDietaryElementSets()">保存</el-button>
        <el-button type="primary" size="medium" @click="nutritionSettingstype()">类型设置量</el-button>
     </div>
     <div class="subject" :style="`height: ${windowHeight - 180}px;`">
         <div class="body">
             <div class="big-box" v-for="(item,index) in datalist" :key="index">
                 <div class="title">
                   <span v-if="item.type==0">幼儿园</span>
                   <span v-if="item.type==1">小低</span>
                   <span v-if="item.type==2">小高</span>
                   <span v-if="item.type==3">初中</span>
                   <span v-if="item.type==4">高中</span>
                   营养参考值设置</div>
                 <div class="ul">
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>能量(g)</span>
                         <el-input-number size="mini" :min="0.1"  :precision="1" :max="item.energyM?item.energyM:10000" v-model="item.energy" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.energy?item.energy:0.1"  :precision="1" :max="10000" v-model="item.energyM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>蛋白质(g)</span>
                         <el-input-number size="mini" :min="0.1"  :precision="1" :max="item.proteinM?item.proteinM:10000" v-model="item.protein" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.protein?item.protein:0.1"  :precision="1" :max="10000" v-model="item.proteinM" controls-position="right"></el-input-number>
                     </div>
                      <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>脂肪(g)</span>
                         <el-input-number size="mini" :min="0.1"  :precision="1" :max="item.fatM?item.fatM:10000" v-model="item.fat" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.fat?item.fat:0.1"  :precision="1" :max="10000" v-model="item.fatM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>碳水化合物(g)</span>
                         <el-input-number size="mini" :min="0.1"  :precision="1" :max="item.carbohydrateM?item.carbohydrateM:10000" v-model="item.carbohydrate" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.carbohydrate?item.carbohydrate:0.1"  :precision="1" :max="10000" v-model="item.carbohydrateM" controls-position="right"></el-input-number>
                     </div>
                      <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>维生素A(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.vitaminAM?item.vitaminAM:1000" v-model="item.vitaminA" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.vitaminA?item.vitaminA:0.001"  :precision="3" :max="1000" v-model="item.vitaminAM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>硫胺素(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.vitaminB1M?item.vitaminB1M:1000" v-model="item.vitaminB1" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.vitaminB1?item.vitaminB1:0.001"  :precision="3" :max="1000" v-model="item.vitaminB1M" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>核黄素(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.vitaminB2M?item.vitaminB2M:1000" v-model="item.vitaminB2" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.vitaminB2?item.vitaminB2:0.001"  :precision="3" :max="1000" v-model="item.vitaminB2M" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>维生素C(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.vitaminCM?item.vitaminCM:1000" v-model="item.vitaminC" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.vitaminC?item.vitaminC:0.001"  :precision="3" :max="1000" v-model="item.vitaminCM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>维生素E(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.vitaminEM?item.vitaminEM:1000" v-model="item.vitaminE" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.vitaminE?item.vitaminE:0.001"  :precision="3" :max="1000" v-model="item.vitaminEM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>钙(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.caM?item.caM:1000" v-model="item.ca" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.ca?item.ca:0.001"  :precision="3" :max="1000" v-model="item.caM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>铁(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.feM?item.feM:1000" v-model="item.fe" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.fe?item.fe:0.001"  :precision="3" :max="1000" v-model="item.feM" controls-position="right"></el-input-number>
                     </div>
                     <div class="li">
                         <span class="name"><span class="red">*&nbsp;</span>锌(mg)</span>
                         <el-input-number size="mini" :min="0.001"  :precision="3" :max="item.znM?item.znM:1000" v-model="item.zn" controls-position="right"></el-input-number>
                         &nbsp;~&nbsp;
                         <el-input-number size="mini" :min="item.zn?item.zn:0.001"  :precision="3" :max="1000" v-model="item.znM" controls-position="right"></el-input-number>
                     </div>
                 </div>
             </div>            
         </div>
     </div>
</div> 
</template>
<script>
import {dietaryElementSet,insertDietaryElementSet} from "@/api/foodSetting";
import windowResize from "@/mixins/windowResize";
export default {
  name: "dataAnalysis",
  data() {
    return {
        datalist:[],
    };
  },
  mixins: [windowResize],
  created() {
    this.dietaryElementSets();
  },
  methods: {
     dietaryElementSets(){
       dietaryElementSet()
        .then(res => {
          const data = res.data.data;
          this.datalist=data;
        }).catch(err => {});
     },
     insertDietaryElementSets(){
       let list=[];
       let namelist=['幼儿园','小低','小高','初中','高中']
       for(let i=0;i<this.datalist.length;i++){
         if(!this.datalist[i].energy){
            this.$message.error(namelist[this.datalist[i].type-0]+"能量初始值不能为空！");
            return;
         }
         if(!this.datalist[i].energyM){
            this.$message.error(namelist[this.datalist[i].type-0]+"能量最大值不能为空！");
            return;
         }
         if(!this.datalist[i].protein){
            this.$message.error(namelist[this.datalist[i].type-0]+"蛋白质初始值不能为空！");
            return;
         }
         if(!this.datalist[i].proteinM){
            this.$message.error(namelist[this.datalist[i].type-0]+"蛋白质最大值不能为空！");
            return;
         }
         if(!this.datalist[i].fat){
            this.$message.error(namelist[this.datalist[i].type-0]+"脂肪初始值不能为空！");
            return;
         }
         if(!this.datalist[i].fatM){
            this.$message.error(namelist[this.datalist[i].type-0]+"脂肪最大值不能为空！");
            return;
         }
         if(!this.datalist[i].carbohydrate){
            this.$message.error(namelist[this.datalist[i].type-0]+"碳水化合物初始值不能为空！");
            return;
         }
         if(!this.datalist[i].carbohydrateM){
            this.$message.error(namelist[this.datalist[i].type-0]+"碳水化合物最大值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminA){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素A初始值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminAM){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素A最大值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminB1){
            this.$message.error(namelist[this.datalist[i].type-0]+"硫胺素初始值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminB1M){
            this.$message.error(namelist[this.datalist[i].type-0]+"硫胺素最大值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminB2){
            this.$message.error(namelist[this.datalist[i].type-0]+"核黄素初始值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminB2M){
            this.$message.error(namelist[this.datalist[i].type-0]+"核黄素最大值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminC){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素C初始值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminCM){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素C最大值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminE){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素E初始值不能为空！");
            return;
         }
         if(!this.datalist[i].vitaminEM){
            this.$message.error(namelist[this.datalist[i].type-0]+"维生素E最大值不能为空！");
            return;
         }
         if(!this.datalist[i].ca){
            this.$message.error(namelist[this.datalist[i].type-0]+"钙初始值不能为空！");
            return;
         }
         if(!this.datalist[i].caM){
            this.$message.error(namelist[this.datalist[i].type-0]+"钙最大值不能为空！");
            return;
         }
         if(!this.datalist[i].fe){
            this.$message.error(namelist[this.datalist[i].type-0]+"铁初始值不能为空！");
            return;
         }
         if(!this.datalist[i].feM){
            this.$message.error(namelist[this.datalist[i].type-0]+"铁最大值不能为空！");
            return;
         }
          if(!this.datalist[i].zn){
            this.$message.error(namelist[this.datalist[i].type-0]+"锌初始值不能为空！");
            return;
         }
         if(!this.datalist[i].znM){
            this.$message.error(namelist[this.datalist[i].type-0]+"锌最大值不能为空！");
            return;
         }
         list.push(this.datalist[i])
       }
       insertDietaryElementSet(list)
            .then(res => {
              const data = res.data;
              if (data.code == 200) {
                this.$message({
                  message: "保存成功！",
                  type: "success",
                  duration: 1000
                });
              }
            })
            .catch(err => {});
     },
     nutritionSettingstype(){
        this.$router.push({
        path: "nutritionSettingstype"
      });
     }
  }
};
</script>
<style>
  .nutritionSettingsindex .el-input-number.is-controls-right .el-input__inner {
    width: 75px;
    padding: 0;
}
.nutritionSettingsindex .el-input-number--mini .el-input-number__decrease,.nutritionSettingsindex .el-input-number.is-controls-right .el-input-number__increase{
  display: none;
}
.nutritionSettingsindex .el-input-number--mini {
    width: 75px;
}
</style>
<style lang="scss" scoped>
.nutritionSettingsindex {
  padding: 12px;
  *{
    box-sizing: border-box;
  }
  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid  #eee;
  }
  .subject{
      overflow: auto;
      .body{
          width: 810px;
          margin: 10px auto;
         .title{
            height: 20px;
            line-height: 20px;
            margin-top: 15px;
            padding-left: 8px;
            border-left: 4px solid #409eff;
            font-weight: bold;
        }
        .ul{
          overflow: hidden;
          .li{
            width: 33%;
            float: left;
            margin: 10px 0;
            font-size: 12px;
            position: relative;
            padding-left: 95px;
            .name{
              position: absolute;
              height: 28px;
              top:0;
              left: 0;
              width: 85px;
              line-height: 28px;
              color: #606266;
              text-align: right;
              .red{
                color:#F56C6C;
              }
            }
          }
        }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/foodSetting/nutritionSettingsindex.vue